const setRequired = (el: HTMLInputElement, isRequired = true) => {
  el.required = isRequired
}

const addressPrefixMap = {
  id_home_add_remove_address: 'id_home_',
  id_postal_add_remove_address: 'id_postal_',
}
const mandatoryAddressFieldNames = [
  'address_line_1',
  'suburb',
  'state',
  'postcode',
  'country',
]
const allAddressFieldNames = mandatoryAddressFieldNames.concat([
  'address_line_2',
])

const isShowingAddress = (prefix: string) => {
  const cardBody = document
    .getElementById(`${prefix}address_line_1`)
    ?.parentElement?.closest('div.card-body')
  if (cardBody) {
    return (cardBody as HTMLElement).style.display !== 'none'
  }
  return false
}

const showHideAddress = (prefix: string, isShow = true) => {
  for (const fieldName of mandatoryAddressFieldNames) {
    setRequired(
      document.getElementById(`${prefix}${fieldName}`) as HTMLInputElement,
      isShow,
    )
  }

  const cardBody = document
    .getElementById(`${prefix}address_line_1`)
    ?.parentElement?.closest('div.card-body')
  if (cardBody) {
    ;(cardBody as HTMLElement).style.display = isShow ? 'block' : 'none'
  }

  const hasAddress = document.getElementById(`${prefix}has_address`)
  if (hasAddress) {
    ;(hasAddress as HTMLInputElement).value = isShow ? '1' : '0'
  }

  const button = document.getElementById(`${prefix}add_remove_address`)
  if (button) {
    button.childNodes[4].nodeValue = isShow ? 'Remove address' : 'Add address'
    if (isShow) {
      button.classList.remove('btn-secondary')
      button.classList.add('btn-danger')
    } else {
      button.classList.remove('btn-danger')
      button.classList.add('btn-secondary')
    }

    const plusIcon = button.getElementsByClassName('add-address')[0]
    if (plusIcon) {
      ;(plusIcon as HTMLElement).style.display = isShow
        ? 'none'
        : 'inline-block'
    }

    const minusIcon = button.getElementsByClassName('remove-address')[0]
    if (minusIcon) {
      ;(minusIcon as HTMLElement).style.display = isShow
        ? 'inline-block'
        : 'none'
    }
  }
}

const isAddressFilled = (prefix: string) => {
  return allAddressFieldNames.some((fieldName) => {
    return (
      (document.getElementById(`${prefix}${fieldName}`) as HTMLInputElement)
        .value.length > 0
    )
  })
}

const configureAddRemoveAddress = (button: HTMLElement, prefix: string) => {
  button.addEventListener('click', (e) => {
    e.preventDefault()
    showHideAddress(prefix, !isShowingAddress(prefix))
  })

  // if any of the address fields is filled up, show address. Otherwise, hide it
  showHideAddress(prefix, isAddressFilled(prefix))
}

const configureAddRemoveAddresses = () => {
  for (const [id, addressPrefix] of Object.entries(addressPrefixMap)) {
    const addRemoveAddress = document.getElementById(id)
    if (addRemoveAddress) {
      configureAddRemoveAddress(addRemoveAddress, addressPrefix)
    }
  }
}

function copyAddress() {
  allAddressFieldNames.forEach((fields) => {
    const homeAddressField = document.getElementById(
      addressPrefixMap.id_home_add_remove_address + fields,
    ) as HTMLInputElement
    const postalAddressField = document.getElementById(
      addressPrefixMap.id_postal_add_remove_address + fields,
    ) as HTMLInputElement
    postalAddressField.value = homeAddressField.value
    postalAddressField.setAttribute('disabled', '')
    showHideAddress(addressPrefixMap.id_postal_add_remove_address)
    homeAddressField.addEventListener('change', function () {
      postalAddressField.value = homeAddressField.value
    })
  })
}

const configureCopyHomeAddress = () => {
  const copyAddressCheckbox = document.getElementById(
    'id_same_address',
  ) as HTMLInputElement
  const submitButton = document.getElementById(
    'submitButton',
  ) as HTMLButtonElement

  if (copyAddressCheckbox) {
    if (copyAddressCheckbox.checked) {
      copyAddress()
    }
    copyAddressCheckbox.addEventListener('change', function () {
      if (this.checked) {
        copyAddress()
      } else {
        allAddressFieldNames.forEach((fields) => {
          const postalAddressField = document.getElementById(
            addressPrefixMap.id_postal_add_remove_address + fields,
          ) as HTMLInputElement
          const homeAddressField = document.getElementById(
            addressPrefixMap.id_home_add_remove_address + fields,
          ) as HTMLInputElement
          // this is to remove all the eventlistener on homAddressField, cloneNode will only copy the element without listener
          homeAddressField.replaceWith(homeAddressField.cloneNode(true))
          postalAddressField.removeAttribute('disabled')
          postalAddressField.value = ''
        })
      }
    })
  }

  if (submitButton) {
    submitButton.addEventListener('click', function () {
      allAddressFieldNames.forEach((fields) => {
        const postalAddressField = document.getElementById(
          addressPrefixMap.id_postal_add_remove_address + fields,
        ) as HTMLInputElement
        postalAddressField.removeAttribute('disabled')
      })
    })
  }
}

function initAddress() {
  configureAddRemoveAddresses()
  configureCopyHomeAddress()
}

export { initAddress }
